
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/games/slots",
      function () {
        return require("private-next-pages/games/slots/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/games/slots"])
      });
    }
  